module.exports = __webpack_public_path__ + "img/table.9c54b379.png";